"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInspectionUserDto = instanceOfInspectionUserDto;
exports.InspectionUserDtoFromJSON = InspectionUserDtoFromJSON;
exports.InspectionUserDtoFromJSONTyped = InspectionUserDtoFromJSONTyped;
exports.InspectionUserDtoToJSON = InspectionUserDtoToJSON;
exports.InspectionUserDtoToJSONTyped = InspectionUserDtoToJSONTyped;
/**
 * Check if a given object implements the InspectionUserDto interface.
 */
function instanceOfInspectionUserDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    return true;
}
function InspectionUserDtoFromJSON(json) {
    return InspectionUserDtoFromJSONTyped(json, false);
}
function InspectionUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'email': json['email'] == null ? undefined : json['email'],
        'isVerified': json['isVerified'],
        'image': json['image'] == null ? undefined : json['image'],
    };
}
function InspectionUserDtoToJSON(json) {
    return InspectionUserDtoToJSONTyped(json, false);
}
function InspectionUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'isVerified': value['isVerified'],
        'image': value['image'],
    };
}
